import { gql } from '@apollo/client';

export const GET_ACTIVITIES = gql`
	query GetActivities($first: Int, $filters: ActivityFilterInput) {
		activities(first: $first, filters: $filters) {
			edges {
				node {
					id
					comment
					canUpdate
					updateUntil
					createdAt
					createdBy {
						id
						name
					}
					lastVersion {
						payloadJson
						items {
							id
							role
							operationType
							entityType
							oldValues
							newValues
							payloadJson
						}
					}
				}
			}
			facets {
				creators {
					id
					name
					count
					selected
				}
				types {
					value
					count
					selected
				}
			}
			totalCount
		}
	}
`;
